import { Header } from "antd/es/layout/layout";
import Navigator from "../Navigator/Index";
import { useLocation } from "react-router-dom";

const AppHeader = () => {
  const { pathname } = useLocation();

  const knownPaths = ["/", "/questionnaire", "/preliminary-match"];
  const excludedPaths = [
    "/sign-in",
    "/sign-up",
    "/forgot-password",
    "/reset-password",
  ];

  const isDashboardRoute =
    /^\/([a-zA-Z0-9]+)?(\/requirements|\/interview-round|\/online-interview|\/result)/.test(
      pathname
    );

  const shouldRenderHeader =
    (knownPaths.includes(pathname) || isDashboardRoute) &&
    !excludedPaths.includes(pathname);

  if (!shouldRenderHeader) {
    return null;
  }

  return (
    <Header style={{ padding: 0 }}>
      <Navigator key="navigator" />
    </Header>
  );
};

export default AppHeader;
